import * as types from '../mutation-types'
import cepreAPI from '@/api/cepre'

export const state = {
  registeredsCepre: [],
  loadingRegisteredsCepre: false,
  currentRegisteredCepre: null,
  showModalPayments: false
}

export const actions = {
  getRegisteredsCepre ({ commit }, payload) {
    commit(types.REPLACE_LOADING_REGISTEREDS_CEPRE, { status: true })

    return new Promise((resolve, reject) => {
      cepreAPI.get(payload)
        .then(response => {
          const registeredsCepre = response.data.data
          commit(types.REPLACE_LOADING_REGISTEREDS_CEPRE, { status: false })
          commit(types.REPLACE_REGISTEREDS_CEPRE, { registeredsCepre })
          resolve(response)
        })
        .catch(error => {
          commit(types.REPLACE_LOADING_REGISTEREDS_CEPRE, { status: false })
          reject(error)
        })
    })
  },
  replaceCurrentRegisteredCepre ({ commit }, payload) {
    commit(types.REPLACE_CURRENT_REGISTERED_CEPRE, payload)
  },
  replaceShowModalPayments ({ commit }, payload) {
    commit(types.REPLACE_SHOW_MODAL_PAYMENTS, payload)
  },
  payments ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      cepreAPI.payments(payload)
        .then(response => {
          this._vm.$notify.success({
            title: 'UNIQ',
            message: 'El usuario ha completado su pago.'
          })
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  getReportExcel ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      cepreAPI.getExcel(payload)
        .then(response => {
          const register = response.data
          commit(types.REPLACE_CURRENT_REGISTERED, { register })
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  }
}

export const mutations = {
  [types.REPLACE_LOADING_REGISTEREDS_CEPRE] (state, { status }) {
    state.loadingRegisteredsCepre = status
  },
  [types.REPLACE_REGISTEREDS_CEPRE] (state, { registeredsCepre }) {
    state.registeredsCepre = registeredsCepre
  },
  [types.REPLACE_CURRENT_REGISTERED_CEPRE] (state, { register }) {
    state.currentRegisteredCepre = register
  },
  [types.REPLACE_SHOW_MODAL_PAYMENTS] (state, { status }) {
    state.showModalPayments = status
  }
}
